import {env} from '../../environment'

export const fetchDeliveryTimes = (options: any) => {
  const url = env.getServiceHost() + 'order/deliveryTime?version=1'

  const form = new FormData()

  let i = 0

  form.append('deliveryCountry', options.deliveryCountry)

  options.cartItems.forEach((data: any) => {
    if (typeof data.materialIId === 'number') {
      form.append('data[' + i + '][materialIId]', data.materialIId)
    } else {
      form.append('data[' + i + '][materialId]', data.materialId)
    }

    i += 1
  })

  if (typeof options.mode === 'string') {
    form.append('mode', options.mode)
  }

  return fetch(url, { method: 'post', body: form }).then(response =>
    response.json(),
  )
}
